/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { Donation } from "../common.interface";
import { toast } from "react-toastify";



export default function useDonation() {
  const [donationData, setDonationData] = useState<Donation[]>([]);
  const [loading, setLoading] = useState(false);

  

  useEffect(() => {
    fetchDonation();
    }
    ,
   []); // Empty dependency array to ensure the effect runs only once

  const fetchDonation = async () =>{
    setLoading(true);

    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/donation/`)
    if (res.status===200){
      const data = res.data.data;
      // console.log(data);

      const newData = data.map((item:Donation)=>({...item,'createdAt':item.createdAt.replace('T'," ").split('.')[0]}))
      setDonationData(newData);  

    }
    } catch (error) {

      toast.error(`${(error as any).message}`, {
        position: toast.POSITION.TOP_LEFT,
        toastId: 'donation-fetch-error'

      });  
      // console.log('=======Fetch Donation Error======');
      // console.log(`${(error as any).message}`);
    }finally{      
      setLoading(false);
    }
  }


  const totalDonation = useMemo(
    () => donationData.reduce((sum, entry) => sum + entry.amount, 0),
    [donationData]
  );

  const averageDonation = useMemo(
    () => totalDonation / donationData.length,
    [donationData.length, totalDonation]
  );

  // Find the maximum and minimum decibel levels
  const maxDonation = useMemo(
    () => Math.max(...donationData.map((entry) => entry.amount)),
    [donationData]
  );

  const minDonation = useMemo(
    () => Math.min(...donationData.map((entry) => entry.amount)),
    [donationData]
  );

  const updateDonation = (_data:Donation)=>{   
    setLoading(true);
    const data =  donationData.map((donation)=>donation._id===_data._id?{..._data}:donation);
    setDonationData(data); 
    setLoading(false);
  }

  const aggregateDonation = {
    maxDonation,
    minDonation,
    averageDonation: averageDonation,
    totalDonation:totalDonation.toFixed(2)
  };

  return {
    donationData,
    aggregateDonation,
    loading,
    updateDonation,
  };
}
